module.exports = __webpack_public_path__ + "img/iPhone-Ui.8a0055b8.png";